export enum ProviderType {
    GITHUB = 'github',
    GITLAB = 'gitlab',
    SLACK = 'slack',
    TEAMS = 'teams',
    EMAIL = 'email',
    SMS = 'sms'
}

export type PlanType = 'free' | 'pro';

export enum EventType {
    PR_CREATED = 'pr.created',
    PR_REVIEW_REQUESTED = 'pr.review_requested',
    PUSH_MAIN = 'push.main',
    ISSUE_CREATED = 'issue.created',
    CI_FAILED = 'ci.failed'
}

export interface RuleSource {
    provider: ProviderType;
    repository: string;
    filters: {
        teams: string[];
        labels: string[];
    };
}

export interface RuleTarget {
    id: string;
    provider: ProviderType;
    target: string; // e.g., Channel ID, Email Address
    targetName?: string; // Display name (e.g., #general for Slack channels)
}

export type Role = 'owner' | 'maintainer' | 'member';
export type MemberStatus = 'active' | 'pending';

export interface Member {
    id: string;
    name?: string; // Optional if pending
    email: string;
    role: Role;
    status: MemberStatus;
    avatarUrl?: string;
}

export interface Organization {
    id: string;
    name: string;
    plan: PlanType;
    role: Role; // User's role in this org
    members: Member[];
}

export interface UserOrganization {
    id: string;
    name: string;
    role: Role;
    plan: PlanType;
}

export interface User {
    id: string;
    full_name: string;
    email: string;
    is_verified: boolean;
    organizations: UserOrganization[];
    avatarUrl?: string;
}

export interface Rule {
    id: string;
    organizationId: string;
    name: string;
    description: string;
    isActive: boolean;
    source: RuleSource;
    targets: RuleTarget[];
    createdAt: string;
}

export type ViewState = 'dashboard' | 'create-rule' | 'integrations' | 'settings' | 'billing';

export interface Integration {
    id: string;
    organizationId: string;
    provider: ProviderType;
    name: string;
    isConnected: boolean;
    connectedAt?: string;
    config?: Record<string, any>;
}

export interface IntegrationDefinition {
    provider: ProviderType;
    name: string;
    description: string;
    features: string[];
}

// Plan-related types
export interface RulesEnableStatus {
    plan: PlanType;
    active_rule_count: number;
    limit: number | null;
    can_enable_more: boolean;
}

export interface DowngradePreview {
    rules_to_disable: Array<{ id: string; name: string }>;
}

export interface FreeTierLimitError {
    error: 'free_tier_limit';
    message: string;
    active_rule_id: string;
    active_rule_name: string;
}

// Re-export installation status types from apiService
export type { SlackInstallationStatus, GitHubInstallationStatus } from './services/apiService';
